/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CuzkCredentials } from './cuzkCredentials.model';
import { DownloadPersonalData } from './downloadPersonalData.model';
import { CtiosRequestSource } from './ctiosRequestSource.model';


export interface DataRequest { 
    budId?: number;
    credentials?: CuzkCredentials;
    downloadPersonalData?: DownloadPersonalData;
    hashes?: Array<string>;
    parId?: number;
    requestSource: CtiosRequestSource;
}
export namespace DataRequest {
}


